<template>
    <div>
        <div>
            <div style="display: flex;align-items: center;text-align-last: center;width: 90%">
              <div class="seo-progress-back">
                <div class="seo-progress-bar" :style="`width:${bar_width}%;background:${bar_color};`"></div>
              </div>
              <label style="font-size:12px;width: 35px;margin-bottom: 0 !important;">{{string.length}}</label>
              <label style="font-size:12px;width: fit-content;margin-bottom: 0 !important;flex: none">({{min_perfect}} - {{ max_perfect }})</label>
            </div>

        </div>


    </div>
</template>

<script>

    export default {
        name: 'SeoProgress',
       components: {},
        props: {
          string: String,
          min_perfect: Number,
          max_perfect: Number,
        },
        data() {
            return {
              model: '',

            }
        },
      watch:{
        'model':function (){
        }
      },
        computed: {
          bar_width(){
            const value = (this.string.length *100) / this.max_perfect;
            if(value>100){
              return 100;
            }
            return value;
          },
          bar_color(){
            if(this.string.length< this.min_perfect){
              return "#fff200"
            }
            if(this.string.length>= this.min_perfect && this.string.length<= this.max_perfect){
              return "#0ed263"
            }
            if(this.string.length> this.max_perfect ){
              return "#ef3737"
            }
            return "#c7c50b"

          }
        },
        mounted() {

        },
        methods: {

        },


    }
</script>
<style>
.seo-progress-back{
  height: 5px;
  border-radius: 5px;
  background: white;
  width: 70%;

}
.seo-progress-bar{
  height: 5px;
  border-radius: 5px;
}
</style>